
import Api from '@/services/Index';
import i18n from '@/plugins/i18n';

const create = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    formData.language = i18n.locale.toUpperCase()
    return Api.post('/student/documents/create', formData);
}

const downloadCourseSchedule = async (id, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = {language: lang.toUpper()};
    return Api.post('/student/documents/course-schedule/' + id, formData, {responseType: 'arraybuffer'});
}

const downloadDispatchPostponement = async (id, lang, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = {
        language: lang.toUpper(),
        ...data}
    return Api.post('/student/documents/dispatch-postponement/' + id, formData, {responseType: 'arraybuffer'});
}

const downloadExamSchedule = async (id, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = {language: lang.toUpper()};
    return Api.post('/student/documents/exam-schedule/' + id, formData, {responseType: 'arraybuffer'});
}

const downloadSchoolCertificate = async (id, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = {language: lang.toUpper()};
    return Api.post('/student/documents/school-certificate/' + id, formData, {responseType: 'arraybuffer'});
}

const downloadLanguageProficiency = async (id, lang, note = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = {language: lang.toUpper()};
    if (note) {
        formData.note = note;
    }
    return Api.post('/student/documents/language-proficiency/' + id, formData, {responseType: 'arraybuffer'});
}

const downloadEnglishPlacementExam = async (id, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = {language: lang.toUpper()};
    return Api.post('/student/documents/english-placement-exam/' + id, formData, {responseType: 'arraybuffer'});
}

const downloadMilitaryStatus = async (id, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = {language: lang.toUpper()};
    return Api.post('/student/documents/military-status/' + id, formData, {responseType: 'arraybuffer'});
}

const downloadNewPassword = async (id, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = {language: lang.toUpper()};
    return Api.post('/student/documents/password/' + id, formData, {responseType: 'arraybuffer'});
}

const downloadPrepTranscript = async (id, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = {language: lang.toUpper()};
    return Api.post('/student/documents/prep-transcript/' + id, formData, {responseType: 'arraybuffer'});
}

const downloadStudentCertificate = async (id, lang, note = null) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let data = {
        language: lang.toUpper()
    };
    if (note) {
        data.note = note;
    }
    return Api.post('/student/documents/student-certificate/' + id, data, {responseType: 'arraybuffer'});
}

const downloadTranscript = async (id, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = {language: lang.toUpper()};
    return Api.post('/student/documents/transcript/' + id, formData, {responseType: 'arraybuffer'})
}

const downloadEslTranscript = async (id, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = {language: lang.toUpper()};
    return Api.post('/student/documents/esl/transcript/' + id, formData, {responseType: 'arraybuffer'})
}

const downloadOfficialTranscript = async (id,row) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    const lang ='en'
    let formData = {language: lang.toUpper()};
    let endpoint;
    if (row.student_type==='mentora'){
        endpoint=`/student/documents/esl/official-transcript/${id}`
    } else {
        endpoint=`/student/documents/official-transcript/${id}`
    }
    return Api.post(endpoint, formData, {responseType: 'arraybuffer'})
}

const downloadOfficialTranscriptForParchment = async (id, lang='en') => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = {language: lang.toUpper()};
    return Api.post('/student/documents/official-transcript-for-parchment/' + id, formData, {responseType: 'arraybuffer'})
}

const downloadTranscriptOfAllPrograms = async (id, lang='en') => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = {language: lang.toUpper()};
    return Api.post('/student/documents/transcript-of-all-programs/' + id, formData, {responseType: 'arraybuffer'})
}

const downloadWelcomeLetter = async (studentNumber, lang) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let formData = {language: lang.toUpper()};
    return Api.post('/student/documents/welcome/' + studentNumber, formData, {responseType: 'arraybuffer'});
}

const downloadGpaControl = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/documents/gpa-control/' + id);
}

const downloadDiploma = (id,formData)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;

    return Api.post('/student/documents/diploma/'+id,formData, {responseType: 'arraybuffer'});
}

const downloadDiplomaAnnexes = (id)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/documents/diploma-supplement/'+id);
}

const downloadTemporaryGraduation = (id)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/documents/temporary-graduation-certificate/'+id,null,{responseType: 'arraybuffer'});
}

const downloadMinorCertificate = (id)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/documents/minor-certificate/'+id,null,{responseType: 'arraybuffer'});
}

const downloadAttendanceList = (section_ID)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/documents/attendance-list/'+section_ID,null,{responseType: 'arraybuffer'});
}

const downloaWeeklydAttendanceList = (section_ID)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/documents/weekly-attendance-list/'+section_ID,{responseType: 'arraybuffer'});
}

const downloadExamReport = (exam_ID='',classroom='') =>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/documents/exam-report/'+exam_ID+'/'+classroom,null,{responseType: 'arraybuffer'});
}

const downloadExamListReport = (exam_ID) =>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/documents/exam-report-list/'+exam_ID,null,{responseType: 'arraybuffer'});
}

const downloadRegistrationForm = (studentProgramId, formData) =>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/student/documents/registration-form/'+studentProgramId,formData,{responseType: 'arraybuffer'});
}

const downloadGpaStudentExcel = (studentProgramId) =>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/documents/gpa-control-excel-export/'+studentProgramId,{responseType: 'arraybuffer'});
}

const downloadDisciplineRegistry = async (id, data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT

    return Api.post('/student/documents/discipline/' + id, data, {
        responseType: 'arraybuffer'
    })
}

const downloadExamReportAllSection = (examId = '', classroom = '') => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/student/documents/all-section-exam-report/' + examId + '/' + classroom, null, {responseType: 'arraybuffer'})
}

const studentAttendanceRecordsReport = async (id,data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/student/documents/daily-attendance-list/' + id,{...data,responseType: 'arraybuffer'})
}

const studentDailySessionPdf = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/student/documents/daily-session-attendance-list/' + id,{responseType: 'arraybuffer'})
}

const studentVerificationLetterPdf = async (student_program_id,data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/student/documents/student-verification-letters/' + student_program_id,data,{responseType: 'arraybuffer'})
}

const getStudentSessions = async (config) => {
    return Api.get('/student/sessions/', config);
}

const certificate_of_achievement = async (student_program_id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/student/documents/esl/certificate-of-achievement/' + student_program_id,{responseType: 'arraybuffer'})
}
const teflProgramDiploma = async (student_program_id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/student/documents/tefl-program-diploma/' + student_program_id,{responseType: 'arraybuffer'})
}
const logs = async (student_program_id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get(`/course/registration/${student_program_id}/logs`)
}

const downloadYouthProgramCertificate = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/documents/youth-program-certificate/' + id, { responseType: 'arraybuffer' });
}

export default {
    create,
    downloadCourseSchedule,
    downloadDispatchPostponement,
    downloadExamSchedule,
    downloadSchoolCertificate,
    downloadLanguageProficiency,
    downloadEnglishPlacementExam,
    downloadMilitaryStatus,
    downloadNewPassword,
    downloadPrepTranscript,
    downloadStudentCertificate,
    downloadTranscript,
    downloadWelcomeLetter,
    downloadGpaControl,
    downloadDiploma,
    downloadDiplomaAnnexes,
    downloadTemporaryGraduation,
    downloadMinorCertificate,
    downloadAttendanceList,
    downloadExamReport,
    downloadExamListReport,
    downloadRegistrationForm,
    downloadGpaStudentExcel,
    downloaWeeklydAttendanceList,
    downloadDisciplineRegistry,
    downloadExamReportAllSection,
    studentAttendanceRecordsReport,
    downloadOfficialTranscript,
    downloadOfficialTranscriptForParchment,
    studentVerificationLetterPdf,
    certificate_of_achievement,
    teflProgramDiploma,
    studentDailySessionPdf,
    getStudentSessions,
    downloadEslTranscript,
    logs,
    downloadYouthProgramCertificate,
    downloadTranscriptOfAllPrograms
}

